import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Lottery {

  static endpoints = {
    index: `${baseUrl}/lottery`,
  };

  static winners() {
    return axios.get(`${this.endpoints.index}/winners`).then((response)=> response.data.winners)
  };

  static currentPoints() {
    return axios.get(`${this.endpoints.index}/current-points`).then((response)=> response.data.currentPoints)
  };

}

